import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import MslMobile from "./MslMobile";
import MslDesktop from "./MslDesktop";

function Msl({ app, config }) {
	const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

	return isMobile ? (
		<MslMobile app={app} config={config} />
	) : (
		<MslDesktop app={app} config={config} />
	);
}

Msl.defaultProps = {
	app: null,
	config: {},
};

Msl.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default Msl;
